import { defineStyle } from "@chakra-ui/react";

export const PlainInputStyles = (blockEditor = false, allowToEnter = false,isDescAnsQues=false) => {
  return {
    backToPreview: defineStyle({
      width: "160px",
      ml: "64px",
    }),
    backToPreviewCustomStyles: defineStyle({
      bg: "#7464CE",
      color: "#FFFFFF",
      border: "1px solid #D9D6ED",
      fontSize: "14px",
      h: "36px",
      borderRadius: "8px",
    }),
    parentEditableDiv: defineStyle({
      display: "grid",
      gridTemplateColumns: "repeat(14, 1fr)",
      gap: "24px",
      alignItems: "center",
      padding: "0px 24px 24px",
      bg: "linear-gradient(139.61deg, rgba(255, 255, 255, 0.3) 4.47%, rgba(255, 255, 255, 0) 98.47%);",
      backdropFilter: "blur(40px)",
    }),
    menuImageContainer: defineStyle({
      gridColumn: { base: "1/3", md: "1/2", lg: "1/3" },
    }),
    tasksPageMenuImageContainer: defineStyle({
      gridColumn: { base: "1/3", md: "1/2", lg: "1/3" },
      marginLeft: ["0px", "0px", "0px", "60px", "30px", "30px"],
    }),
    emptyPracticeMenuImageContainer: defineStyle({
      gridColumn: { base: "1/3", md: "1/2", lg: "1/2" },
      marginLeft: ["0px", "0px", "0px", "0px", "0px", "0px"],
    }),
    menuImage: defineStyle({
      cursor: "pointer",
      opacity: "1",
      userSelect: "none",
      marginRight: 0,
      marginLeft: { base: "0px", md: "0px", lg: "0px" },
      width: "40px",
      height: "40px",
    }),
    containerInputReview: defineStyle({
      gridColumn: { base: "3/15", md: "2/14", lg: "3/13" },
      display: "flex",
      // borderRadius: "16px",
      flexDirection: "column",
      // padding: "8px 16px",
      // borderColor: "grey",
      backgroundColor: "white",
      // borderWidth: "1px",
      width: "100%",
      alignItems: "flex-start",
      ml: ["0px", "0px", "0px", "-4%", "-4%", "-4%"],
      opacity: "0.5",
    }),
    containerInput: defineStyle({
      gridColumn: { base: "3/15", md: "2/14", lg: "3/13" },
      display: "flex",
      // borderRadius: "16px",
      flexDirection: "column",
      // padding: "8px 16px",
      // borderColor: "grey",
      backgroundColor: "white",
      // borderWidth: "1px",
      width: "100%",
      alignItems: "flex-start",
      opacity: !(blockEditor || !allowToEnter) ? "1" : "0.5",
    }),
    tasksPageContainerInput: defineStyle({
      gridColumn: { base: "3/15", md: "2/14", lg: "3/15" },
      marginLeft: ["0px", "0px", "30px", "-30px", "-90px", "-120px"],
      display: "flex",
      borderRadius: "8px",
      flexDirection: "column",
      padding: "8px",
      borderColor: "grey",
      backgroundColor: "white",
      borderWidth: "1px",
      width: ["100%", "100%", "94%", "94%", "100%", "100%"],
      alignItems: "flex-start",
    }),
    emptyPracticeContainerInput: defineStyle({
      gridColumn: { base: "3/15", md: "2/14", lg: "2/15" },
      marginLeft: ["0px", "0px", "0px", "-20px", "-40px", "-60px"],
      display: "flex",
      borderRadius: "8px",
      flexDirection: "column",
      padding: "8px",
      borderColor: "grey",
      backgroundColor: "white",
      borderWidth: "1px",
      width: ["100%", "100%", "94%", "94%", "100%", "80%"],
      alignItems: "flex-start",
    }),
    editableDivSubmit: defineStyle({
      display: "flex",
      width: "100%",
      alignItems: "center",
      justifyContent: "space-between",
    }),
    multiLineText: defineStyle({
      fontFamily: "Poppins",
      fontSize: "12px",
      fontWeight: "400",
      lineHeight: "20px",
      top: "7px",
      left: "17px",
      gap: "0px",
      textColor: "#787C7E",
    }),
    multiLineBox: defineStyle({
      width: "48px",
      height: "18px",
      top: "9px",
      mx: "10px",
      my: "2px",
      gap: "9px",
      borderColor: "#BFBEDC",
      borderRadius: "4px",
      borderWidth: "1px",
      backgroundColor: "#F5F5F5",
      fontFamily: "Poppins",
      fontSize: "12px",
      fontWeight: "500",
      lineHeight: "16px",
      textAlign: "center",
      color: "black",
    }),
    editableDivContainer: defineStyle({
      display: "flex",
      width: "100%",
      backgroundColor: "white",
      minH: "44px",
      position: "relative",
      alignItems: "center",
      overflowY: "auto",
      maxH: "120px",
    }),
    formulaIconAllowed: defineStyle({
      // borderColor: "#b4addc",
      // borderWidth: "1px",
      // backgroundColor: "#e5e5f1",
      // borderRadius: "4px",
      marginRight: "4px",
      opacity: "1",
      position: "fixed",
    }),
    formulaBox: defineStyle({
      borderColor: "#b4addc",
      borderWidth: "1px",
      backgroundColor: "#e5e5f1",
      borderRadius: "4px",
    }),
    formulaIconNotAllowed: defineStyle({
      // borderColor: "#b4addc",
      // borderWidth: "1px",
      // backgroundColor: "#e5e5f1",
      // borderRadius: "4px",
      marginRight: "4px",
      opacity: "0.5",
      position: "fixed",
    }),
    formulaIconImage: defineStyle({
      height: "28px",
      width: "28px",
      cursor: "pointer",
    }),
    subEditableContainer: defineStyle({
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      width: "95%",
      overflowY: "auto",
      paddingLeft: isDescAnsQues ? "78px" : "38px",
      maxH: "120px",
    }),
    submitBtnWrapperImage: defineStyle({
      height: { base: "24px", md: "28px", lg: "32px" },
      width: { base: "24px", md: "28px", lg: "32px" },
    }),
  };
};
